import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import Moment from "moment";
import {
  getShipManagementDetails,
  getShipEquipmentDetails,
  UpdateEquipmentDetails,
  getShipManagementList,
} from "../Actions/ShipManagementAPI";
import {
  getShipSearchlist,
} from "../Actions/MMPLDashboardAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import userRoles from "../helpers/role";
import { DownloadFirePlanAttachment } from "../Actions/AttachmentAPI";
import i18n from "./DropdownLanguage/i18n";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");

let searchData = {
  IsClient: false,
  shipName: "",
  category: "",
  imoNo: "",
  client: "",
  status: "alldrafts",
  serviceStatus: "",
  nextServiceDateFrom: "",
  nextServiceDateTo: "",
  pagesize: 25,
  pagenumber: 1,
  noofrecords: 2,
  ServiceTypes: [],
  isTotalShips: true,
  isOverdueShips: false,
  isShipsDue10: false,
  isShipsDue30: false,
  isShipsDue60: false,
  isShipsDue90: false,
  action: 1,
};
class PendingShipDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      inContract: false,
      notInContract: false,
      isBoth: true,
    };
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
    };
  }
  componentDidMount() {
    
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch({
      type: "SubBannerTitle",
      data: "Pending Ship Dashboard",
    });
    dispatch(getShipManagementDetails(id));
    dispatch(getShipEquipmentDetails(id));
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    // this.props.history.push("/Home/ShipManagement");
    this.props.history.push("/Home/PendingShip");
  };
  render() {
    const { ShipDetails, ShipEquipment, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                    style={{ display: 'inline-flex', alignItems: 'center' }}
                  >
                    <span style={{ marginTop: '-1px' }}>&larr;</span>{t("CommonText.Return")}
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ShipManagementContent.BasicDetails")}
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">

                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("content.Shipname")} : </strong>
                            {ShipDetails ? ShipDetails.shipName : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("content.IMOno")}  </strong>
                            <strong>:</strong>
                            {ShipDetails ? ShipDetails.imoNo : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("TopPaneContent.Flag")} : </strong>
                            {ShipDetails ? ShipDetails.flag : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("TopPaneContent.Class")} : </strong>

                            {ShipDetails ? ShipDetails?.class?.length === 0 ? " " : ShipDetails?.class?.length > 1 ? ShipDetails?.class?.map((item) => { return item }).join(',' + " ")
                              : ShipDetails?.class?.map((i) => i) : ""} {" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("TopPaneContent.TypeofShip")} : </strong>
                            {ShipDetails ? ShipDetails.typeOfShip : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("ShipEquipmentStatusScreen.DateofBuild")}  </strong>
                            <strong>:</strong>

                          </span>
                          {ShipDetails
                            ? Moment(
                              new Date(Date.parse(ShipDetails.dateOfBuild))
                            ).format("DD MMM YYYY")
                            : ""}{" "}
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("ShipManagementContent.GRT")} : </strong>
                            {ShipDetails ? ShipDetails.grt : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("ShipManagementContent.DeadWeight")} : </strong>
                            {ShipDetails ? ShipDetails.deadWeight : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                            <strong>{t("EquipmentSeviceDetailsScreen.EnrollmentDate")} </strong>
                            <strong>:</strong>

                          </span>
                          {ShipDetails
                            ? Moment(
                              new Date(Date.parse(ShipDetails.enrollmentDate))
                            ).format("DD MMM YYYY")
                            : ""}{" "}{" "}
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("ShipEquipmentStatusScreen.FirePlan")} : </strong>
                            <span >
                              {ShipDetails ? ShipDetails.firePlanName : ""}{" "}
                            </span>

                            {ShipDetails?.firePlanName ? (
                              <i
                                className="fa fa-download click ml-1"
                                onClick={() =>
                                  this.DownloadDoc(
                                    ShipDetails.firePlanName,
                                    ShipDetails.firePlanGUID
                                  )
                                }
                                aria-hidden="true"
                                style={{
                                  color: " #1a3464",
                                  fontSize: "1.2rem",
                                }}
                              ></i>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("ShipEquipmentStatusScreen.ContractAttachment")} : </strong>
                            <span >
                              {ShipDetails ? ShipDetails?.agreementName : ""}{" "}
                            </span>

                            {ShipDetails?.agreementName ? (
                              <i
                                className="fa fa-download click ml-1"
                                onClick={() =>
                                  this.DownloadDoc(
                                    ShipDetails?.agreementName,
                                    ShipDetails?.agreementGUID
                                  )
                                }
                                aria-hidden="true"
                                style={{
                                  color: " #1a3464",
                                  fontSize: "1.2rem",
                                }}
                              ></i>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ShipManagementContent.ShipContactDetails")}
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("DashboardMoreInformation.ShipEmail")} : </strong>
                            {ShipDetails ? ShipDetails.shipEmail : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span className={`${isArabic ? 'arabic' : ''}`}>
                            <strong>{t("DashboardMoreInformation.ShipContactNumber1")} </strong>
                            <strong>:</strong>
                            {ShipDetails ? ShipDetails.phone1 : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("DashboardMoreInformation.ShipContactNumber2")} : </strong>
                            {ShipDetails ? ShipDetails.phone2 : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("DashboardMoreInformation.InvoiceForwardingEmail")} : </strong>
                            {ShipDetails
                              ? ShipDetails.invoiceForwardingEmail
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("DashboardMoreInformation.VesselGroupEmail")} : </strong>
                            {ShipDetails
                              ? ShipDetails.vesselGroupEmail
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("DashboardMoreInformation.CompanyDetails")}
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("ShipManagementContent.CompanyName")} : </strong>
                            {ShipDetails ? ShipDetails.companyName : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6 mb-2">
                          <span>
                            <strong>{t("ShipManagementContent.FleetManager")} : </strong>
                            {ShipDetails?.fleetManager ? ShipDetails.fleetManager.join(', ') : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("ShipManagementContent.TechnicalSuperintendent")}: </strong>
                            {ShipDetails?.technicalSuperintendent
                              ? ShipDetails.technicalSuperintendent.join(', ')
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("ShipManagementContent.TechnicalExecutive")} : </strong>
                            {ShipDetails?.technicalExecutive
                              ? ShipDetails.technicalExecutive.join(', ')
                              : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ShipManagementContent.Contract")}
                      </h5>
                    </div>
                    <div className="pt-3 pb-3 search-filter-box">
                      <div className="row">
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("ShipManagementContent.ContractName")} : </strong>
                            {ShipDetails ? ShipDetails.contractName : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("ShipManagementContent.ContractStatus")} : </strong>
                            {ShipDetails ? ShipDetails.contractStatus : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ShipManagementContent.AssignUsers")}
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box history-box">
                      <div className="row">
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("ShipManagementContent.CoordinatorName")}: </strong>
                            {/* {ShipDetails ? ShipDetails.grantAdmin : ""}{" "} */}
                            {ShipDetails
                              ? ShipDetails?.grantAdmins?.map(admin => admin.name).join(', ')
                              : ""}{" "}
                          </span>
                        </div>
                        <div className="col-sm-6">
                          <span>
                            <strong>{t("ShipManagementContent.ApproverName")} : </strong>
                            {ShipDetails ? ShipDetails.approver : ""}{" "}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ComplianceandBudgetScreen.Equipments")}
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box history-box">
                      {ShipEquipment
                        ? ShipEquipment.map((item) => (
                          <div
                            className="card MM-card-content mb-2 click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-md-11 col-sm-10 col-10 m-auto">
                                    <div className="row">
                                      <div className="col-sm-12 mb-2">
                                        <h6 className="resource-list-title">
                                          {item.equipment}{" "}
                                        </h6>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("TopPaneContent.Category")} : </strong>
                                          {item.category}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("ComplianceandBudgetScreen.Type")} : </strong>
                                          {item.equipmentType}{" "}
                                        </span>
                                      </div>
                                      {item?.equipment.toLowerCase().includes("lifeboat") ?
                                        <>
                                          <div className="col-sm-6 mb-2">
                                            <span>
                                              <strong>{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </strong>
                                              {item.lifeboatMake}{" "}
                                            </span>
                                          </div>
                                          <div className="col-sm-6 mb-2">
                                            <span>
                                              <strong> {t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </strong>
                                              {item.davitwinchMake}{" "}
                                            </span>
                                          </div>
                                          <div className="col-sm-6 mb-2">
                                            <span>
                                              <strong> {t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </strong>
                                              {item.lifeboatModel}{" "}
                                            </span>
                                          </div>
                                          <div className="col-sm-6 mb-2">
                                            <span>
                                              <strong> {t("EditEquipmentScreenContent.LifeboatRelease")} :{" "} </strong>
                                              {item.lifeboatRelease}{" "}
                                            </span>
                                          </div>
                                        </>
                                        : item?.equipment.toLowerCase().includes("rescue boat") ?
                                          <>
                                            <div className="col-sm-6 mb-2">
                                              <span>
                                                <strong>{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </strong>
                                                {item.rescueboatMake}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                              <span>
                                                <strong>{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </strong>
                                                {item.rescueboatdavitwinchMake}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                              <span>
                                                <strong>{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </strong>
                                                {item.rescueboatModel}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                              <span>
                                                <strong> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </strong>
                                                {item.rescueboatRelease}{" "}
                                              </span>
                                            </div>
                                          </>
                                          :
                                          <>
                                            <div className="col-sm-6 mb-2">
                                              <span>
                                                <strong>{t("ShipEquipmentStatusScreen.Make")} : </strong>
                                                {item.make}{" "}
                                              </span>
                                            </div>
                                            <div className="col-sm-6 mb-2">
                                              <span>
                                                <strong>{t("ShipEquipmentStatusScreen.Model")} : </strong>
                                                {item.model}{" "}
                                              </span>
                                            </div></>}
                                      <div className="col-sm-6">
                                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                          <strong>
                                            {t("ShipEquipmentStatusScreen.ManufacturingDate")} {" "}
                                          </strong>
                                          <strong>:</strong>

                                        </span>
                                        {Moment(
                                          new Date(
                                            Date.parse(
                                              item.manufracturingDate
                                            )
                                          )
                                        ).format("DD MMM YYYY")}{" "}
                                      </div>
                                      <div className="col-sm-6">
                                        <span className={`${isArabic ? 'arabic' : ''}`}>
                                          <strong>{t("ShipEquipmentStatusScreen.Quantity")}  </strong>
                                          <strong>:</strong>
                                          {item.quantity > 0 ? item.quantity : ""}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6">
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Unit-Quantity")} : </strong>
                                          {item.unit}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6">
                                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                                          <strong>{t("ShipEquipmentStatusScreen.Capacity")}  </strong>
                                          <strong>:</strong>

                                        </span>
                                        {item.capacity}{" "}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-1 col-sm-2 col-2 m-auto">
                                    <i
                                      className="fa fa-eye fa-2x click"
                                      aria-hidden="true"
                                      onClick={() =>
                                        this.ViewEquipment(
                                          item.equipmentId,
                                          item.shipEquipmentId
                                        )
                                      }
                                      style={{
                                        color: "#1a3464",
                                        marginLeft: "-10px",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                  </div>
                  <div
                    className={user === userRoles.approver ? "d-none" : "row"}
                  >
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.EditShipDetails()}
                        >
                          {t("IntervelScreen.Edit")}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.deleteShipDetails()}
                        >
                          {" "}
                          {t("CommonText.Delete")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  ViewEquipment(id, shipEquipmentId) {
    this.props.history.push(`/Home/View/Equipment/${id}/${shipEquipmentId}`);
  }
  DownloadDoc(firePlanName, firePlanGUID) {
    this.props.dispatch(DownloadFirePlanAttachment(firePlanName, firePlanGUID));
  }

  EditShipDetails() {
    this.props.dispatch({
      type: "companyName",
      data: this.props.ShipDetails.companyName,
    });
    this.props.history.push(`/Home/PendingShipEdit/${this.props.match.params.id}`);

    this.props.dispatch({ type: "ShowSidePan", data: false });

  }
  deleteShipDetails() {
    const { ShipDetails, dispatch, ShipEquipment, t, PendingShipsearchData } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            let userarray = [];
            let grandAdmins = ShipDetails?.grantAdmins ? ShipDetails.grantAdmins.map((data) => ({
              id: data.id,
              name: data.name
            })) : [];
            ShipDetails.fleetManager && ShipDetails.fleetManager.map((data, index) => {
              let userdata = { "userName": data, "role": 'fleetmanager' };
              userarray.push(userdata);
            })
            ShipDetails.technicalExecutive && ShipDetails.technicalExecutive.map((data, index) => {
              let userdata = { "userName": data, "role": 'technicalexecutive' };
              userarray.push(userdata);
            })
            ShipDetails.technicalSuperintendent && ShipDetails.technicalSuperintendent.map((data, index) => {
              let userdata = { "userName": data, "role": 'superintendent' };
              userarray.push(userdata);
            })
            let shipInfo = {
              shipId: this.props.match.params.id,
              contractId: ShipDetails.contractId ? ShipDetails.contractId : 0,
              shipName: ShipDetails.shipName,
              flag: ShipDetails.flag,
              class: ShipDetails.class ? ShipDetails.class.toString() : "",
              grt: ShipDetails.grt,
              imoNo: ShipDetails.imoNo,
              deadWeight: ShipDetails.deadWeight,
              dateOfBuild: ShipDetails.dateOfBuild,
              typeOfShip: ShipDetails.typeOfShip,
              shipEmail: ShipDetails.shipEmail,
              approverId: ShipDetails.approverId,
              grantAdmins:grandAdmins,
              status: ShipDetails.status,
              invoiceForwardingEmail: ShipDetails.invoiceForwardingEmail,
              vesselGroupEmail: ShipDetails.vesselGroupEmail,
              phone1: ShipDetails.phone1,
              phone2: ShipDetails.phone2,
              companyName: ShipDetails.companyName,
              fleetManager: ShipDetails.fleetManager,
              technicalSuperintendent: ShipDetails.technicalSuperintendent,
              technicalExecutive: ShipDetails.technicalExecutive,
              contractName: ShipDetails.contractName,
              contractStatus: ShipDetails.contractStatus,
              isDeleted: true,
              modifiedBy: currentuser.name,
              shipUsers: userarray,
            };
            let equip = ShipEquipment
              ? ShipEquipment.map((item) => {
                let equipmentinfo = {
                  shipId: item.shipId,
                  equipmentId: item.equipmentId,
                  equipmentContractTypeId: item.equipmentContractTypeId ? item.equipmentContractTypeId : 0,
                  shipEquipmentId: item.shipEquipmentId,
                  equipment: item.equipment,
                  manufracturingDate: item.manufracturingDate,
                  makeId: item.makeId,
                  modelId: item.modelId,
                  quantity: item.quantity,
                  serviceDetails: item.serviceDetails,
                  modifiedBy: currentuser.name,
                  isDeleted: true,
                };
                return equipmentinfo;
              })
              : [];
            let url = `${API.getShipDetail}`;
            axios
              .put(url, shipInfo)
              .then((response) => {
                dispatch(UpdateEquipmentDetails(equip));
                this.hideSidePanel();
                if (PendingShipsearchData) {
                  dispatch(getShipSearchlist(PendingShipsearchData, this.state.inContract, this.state.isBoth));
                } else {
                  dispatch(getShipSearchlist(searchData, this.state.inContract, this.state.isBoth));
                }

                dispatch({
                  type: "UpdateShipDetailSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {
                dispatch({
                  type: "UpdateShipDetailFailure",
                  data: "error",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { },
        },
      ],
    });
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShowMISidePan: state.SidePanReducer.ShowMISidePan || false,
    ShowRDSidePan: state.SidePanReducer.ShowRDSidePan || false,
    ShowEURegSidePan: state.SidePanReducer.ShowEURegSidePan || false,
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
    ShipEquipment: state.MasterScreenReducer.ShipEquipmentDetails,
    PendingShipsearchData: state.SidePanReducer.PendingShipsearchData,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PendingShipDetails)
));
